<template>
  <!-- D: 쿠키설정 레이어팝업 -->
  <!-- D: 활설화시 클래스 is-active 추가 -->
  <div class="c-cookie-popup" :class="{ 'is-active': true }">
    <div class="content-inner">
      <div class="text">
        <p class="c-title-level2">쿠키 설정을 확인해주세요.</p>
        <p class="sub-text">
          노루 PAINT PRO 사이트는 서비스 제공 및 서비스 품질 개선과 트래픽
          분석을 위해 쿠키를 사용합니다.<br />
          수집된 데이터는 익명으로 처리되며 개인을 식별하는 데 사용되지
          않습니다.
        </p>
      </div>
      <button type="button" class="c-btn-agree" @click="btnCmd('handleOk')">
        <span class="bold"> 동의함 </span>
      </button>
    </div>
  </div>
  <!-- // D: 쿠키설정 레이어팝업 -->
</template>
<script setup name="cookiePop">
import { onMounted, reactive, inject } from "vue";

import { api } from "@/plugins/api";
const url = inject("url_prefix");
import * as cmApi from "@/api/cmApi";

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    userLoginInfo: {},
    basketCount: {},
    breadcrumbItems: [
      { name: "zsample", path: "/paintpro/zsample" },
      { name: "zsample10", path: "/paintpro/zsample/zsample10" },
    ],
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {},
  biz1: {
    mode: "", // 모드 {"", "new", "view", "edit"}
    search: {
      col01: "x8110",
      col02: "",
    },
    list: [], // 목록
    detail: {
      sample02Sn: 0,
      col01: "",
      col02: "",
    },
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  searchCmd("biz1#search9999"); // biz1 데이타 조회
  data.popup.isCookieAgree = true;
  cmApi.checkCookiePop();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: cookiePop.pageInitData] `);
    return false;
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#search") {
    // ◼◼◼ biz1 조회
    data.biz1.loading = true;
    const res = await api.get(`${url}/zsample01/page`, {
      params: {
        ...data.biz1.search,
        page: parms["page"] || 1,
        limit: parms["limit"] || data.biz1.limit,
      },
    });
    data.biz1.list = res.data.list;
    data.biz1.page = parms["page"] || 1;
    data.biz1.totalCount = res.data.totalCount;
    data.biz1.totalPage = data.biz1.totalCount
      ? Math.ceil(data.biz1.totalCount / data.biz1.limit)
      : 0;
    data.biz1.loading = false;
    data.biz1.mode = "";
    // } else {
    //   alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    //   return false;
  }
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "handleOk") {
    cmApi.updateUserPersonInfo({
      type: "cookieUserAgreeYn",
      cookieUserAgreeYn: "Y",
    });
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
<style scoped></style>
